import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Article from "../../../components/CommonCompnents/resourcePage/Article";
import VideoBanner from "../../../components/CommonCompnents/resourcePage/VideoBanner";
import Video from "../../../components/CommonCompnents/resourcePage/Video";

import controlTrade from "../../../assets/images/trading-control.svg";
import learnTrade from "../../../assets/images/offerings.svg";
import python from "../../../assets/images/python.svg";
import node from "../../../assets/images/node.svg";
import java from "../../../assets/images/java.svg";
import OfferSection from "../../../components/CommonCompnents/Home/OfferSection";
import {
  GetAccecssTitle,
  GetAccessHome,
  Offers,
  OfferTitle,
  ResourceObject,
} from "../../Constants/commenFeatures";
import "../../../assets/scss/components/home.scss";
import Footer from "../Footer";
import { MyAuthContext } from "../../../Context/AuthContext";
import InputField from "../../../components/generic/inputField";
import { signFormSubmit } from "../../../services/Signup/SignupApiServices";
import debounce from "../../../components/utils/debounce";
import {
  alphabetExp,
  betweenNChars,
  emailRegex,
  integerExp,
  phoneNo,
} from "../../../components/utils/regex";
import { AGetCities } from "../../../services/login/loginApiService";
import Autocomplete from "../../../components/generic/autocomplete";
import { getFaqs } from "../../../services/Faqs&Resourse/faqsServices";
import { getResoucesContent } from "../../../services/Faqs&Resourse/resource";
import { fnBrowserDetect, getDevice } from "../../../services/genralServise";

import {
  removeServerErrors,
  constants,
  slicedData,
} from "../../Constants/commenFeatures";
import GetAccess from "../../../components/CommonCompnents/Home/GetAccess";
import urlConfig, { config } from "../../../config/domain";
import introVideo from '../../../assets/video/APIrevised2.mp4'
import useDocumentTitle from "../../../utils/useDocumentTitle";

const Home = () => {
  const authContext = useContext(MyAuthContext);
  const [faqs, setFaqs] = useState({
    faqData: "",
    faqId: "",
  });

  const [resouces, setResouces] = useState({
    articles: [],
    videos: [],
  });

  const [cities, setCities] = useState(null);
  const [signupFormVal, setSignupFormVal] = useState({
    nm: "",
    eml: "",
    phNo: "",
    city: "",
    state: "",
    submitedBy: "Individual",
    // compName: "",
  });
  const [isServerErr, setIsServerErr] = useState({
    isSuccess: "",
    isRejected: "",
  });

  const [signupErr, setSignupErr] = useState({
    nm: undefined,
    eml: undefined,
    phNo: undefined,
    city: undefined,
    compName: undefined,
  });

  const mp4VideoObj = {
    name: "Introducing Nuvama API Connect",
    description: "Introducing Nuvama API Connect",
    emtDescription: "<p> Introducing Nuvama API Connect </p>",
    resourceId: "mp4-1",
    date: "2024-01-01T00:00:00.000+05:30",
    url: introVideo,
    ishighlighted: true,
    segment: "product",
    tag: ["Intro"],
    type: "mp4",
  };

  useDocumentTitle("Home");
  const getFaqsRes = (res) => {
    res = {
    "appID": "4fe68b7536784e3407c3ecf19be7c4ad",
    "config": {
        "app": 1,
        "bseExp": 1778198426079,
        "exp": 1778198426069,
        "info": 4
    },
    "data": {
        "type": "faqTabResponseDao",
        "clntFaq": {
            "qa": [
                {
                    "answer": "<p><span lang=\"en-US\"><strong>Nuvama&nbsp;API connect</strong> is a platform that lets you trade using our RESTful APIs. It is a fast and secure way to trade and is capable of handling institutional level order loads. You can execute orders in real-time, manage your portfolio, stream live market data (WebSockets), and more, by integrating into our libraries. These libraries provide easy to use abstraction over the HTTP APIs. The HTTP calls have been converted to methods and their JSON responses are returned. Currently, these libraries are available in Python, Node JS and Java, other languages will be launched soon.</span></p>",
                    "emtAnswer": "Nuvama API connect is a platform that lets you trade using our RESTful APIs. It is a fast and secure way to trade and is capable of handling institutional level order loads. You can execute orders in real-time, manage your portfolio, stream live market data (WebSockets), and more, by integrating into our libraries. These libraries provide easy to use abstraction over the HTTP APIs. The HTTP calls have been converted to methods and their JSON responses are returned. Currently, these libraries are available in Python, Node JS and Java, other languages will be launched soon.",
                    "id": 1,
                    "question": "What is Nuvama API connect?",
                    "questionPriority": 1,
                    "url": "/faqs/what-is-nuvama-api-connect-2-1"
                },
                {
                    "answer": "<p>Nuvama&nbsp;API connect is completely&nbsp;<strong>free</strong>&nbsp;for the first year for customers who sign up for the service during the promotional offer window. Please check out our<a href=\"https://www.nuvamawealth.com/api-connect/\">&nbsp;home page</a>&nbsp;for details of the offer. Please note that your normal brokerage charges will still apply for any trades that you do.</p>",
                    "emtAnswer": "Nuvama API connect is completely free for the first year for customers who sign up for the service during the promotional offer window. Please check out our home page for details of the offer. Please note that your normal brokerage charges will still apply for any trades that you do.",
                    "id": 3,
                    "question": "Do I need to pay to use this service?",
                    "questionPriority": 2,
                    "url": "/faqs/do-i-need-to-pay-to-use-this-service-2-3"
                },
                {
                    "answer": "<p>1. Complete access to our free APIs<br />2. Robust APIs built to handle trading at scale<br />3. Access live market feeds through WebSocket stream<br />4. View trades, place orders and access your account securely in real-time<br />5. Analyze your trading behavior on APIs using our intuitive dashboard<br />6. Access to quality customer support<br />7. Analytics to monitor your trading behavior with our intuitive &amp; simplified dashboard</p>",
                    "emtAnswer": "Complete access to our free APIs\nRobust APIs built to handle trading at scale\nAccess live market feeds through WebSocket stream\nView trades, place orders and access your account securely in real-time\nAnalyze your trading behavior on APIs using our intuitive dashboard\nAccess to quality customer support\nAnalytics to monitor your trading behavior with our intuitive & simplified dashboard",
                    "id": 4,
                    "question": "What are the different functionalities offered by Nuvama API connect?",
                    "questionPriority": 3,
                    "url": "/faqs/what-are-the-different-functionalities-offered-by-nuvama-api-connect-2-4"
                },
                {
                    "answer": "<p>1.&nbsp;Nuvama Clients who are willing to execute orders basis their own analysis in an automated way.<br />2. Start-ups building innovative solutions for stock trading.<br />3. Platforms and websites catering to investing and trading audiences.</p>",
                    "emtAnswer": "Nuvama Clients who are willing to execute orders basis their own analysis in an automated way.\nStart-ups building innovative solutions for stock trading.\nPlatforms and websites catering to investing and trading audiences.",
                    "id": 5,
                    "question": "Who should subscribe to Nuvama API connect?",
                    "questionPriority": 4,
                    "url": "/faqs/who-should-subscribe-to-nuvama-api-connect-2-5"
                },
                {
                    "answer": "<p>We currently support Python, Node and Java&nbsp; languages</p>",
                    "emtAnswer": "We currently support Python, C#, Node and Java  languages",
                    "id": 6,
                    "question": "Which programming languages are supported by Nuvama API connect?",
                    "questionPriority": 5,
                    "url": "/faqs/which-programming-languages-are-supported-by-nuvama-api-connect-2-6"
                },
                {
                    "answer": "<p>You can reach out through email at APIConnect@nuvama.com&nbsp;or by calling&nbsp; 1800 - 102 - 3335 (Weekdays 09 AM - 06 PM)</p>",
                    "emtAnswer": "You can reach out through email at APIconnect@nuvama.com or by calling  1800 - 102 - 3335 (Weekdays 09 AM - 06 PM)",
                    "id": 7,
                    "question": "How do I reach out to the customer support team for queries related to Nuvama API connect?",
                    "questionPriority": 6,
                    "url": "/faqs/how-do-i-reach-out-to-the-customer-support-team-for-queries-related-to-nuvama-api-connect-2-7"
                },
                {
                    "answer": "<p>In this case it is always advisable to provide us with the LOG FILE. The log file shall be present in your directory by name edlwsapi.log. Providing log file will help us diagnose the issue and address it at the earliest.</p>",
                    "emtAnswer": "In this case it is always advisable to provide us with the LOG FILE. The log file shall be present in your directory by name edlwsapi.log. Providing log file will help us diagnose the issue and address it at the earliest.",
                    "id": 12,
                    "metaTag": "",
                    "question": "Are you facing any difficulties while executing any of the API functionalities?",
                    "questionPriority": 7,
                    "url": "/faqs/are-you-facing-any-difficulties-while-executing-any-of-the-api-functionalities-2-12"
                },
                {
                    "answer": "<p>Using&nbsp;Nuvama API connect, you can trade in Cash, Derivatives, Currency and Commodity segments. Order types supported are Limit, Market, SL, SL-M, Day, IOC, EOS, GTD, GTC and AMO. The supported product types are CNC, NRML, MIS, MTF, Cover Order, Bracket Order and Basket Order.</p>",
                    "emtAnswer": "Using Nuvama API connect, you can trade in Cash, Derivatives, Currency and Commodity segments. Order types supported are Limit, Market, SL, SL-M, Day, IOC, EOS, GTD, GTC and AMO. The supported product types are CNC, NRML, MIS, MTF, Cover Order, Bracket Order and Basket Order.",
                    "id": 8,
                    "question": "What are the different product types, order types and segments available for trading via Nuvama API connect?",
                    "questionPriority": 8,
                    "url": "/faqs/what-are-the-different-product-types-order-types-and-segments-available-for-trading-via-nuvama-api-connect-2-8"
                },
                {
                    "answer": "<p>In order to put the end user at ease we have now provided you with code snippet of python. It's time to login and start trading with APIs.</p>\n<p>&nbsp;</p>\n<p>Here is the login code snippet:</p>\n<p>&nbsp;</p>\n<p>pip install APIConnect</p>\n<p><br /> api = APIConnect(\"apikey\",\"secret_password\",\"requestID\",True,r\"D:\\nuvama python\\APIConnect-2.0.1.post1\\conf\\settings.ini\")</p>\n<p>&nbsp;</p>\n<p>Important points:</p>\n<ul>\n<li>Api key and secret password gets generated when creating an app <a href=\"https://www.nuvamawealth.com/api-connect/\" target=\"_blank\">here</a></li>\n</ul>\n<ul>\n<li>Please login <a href=\"https://www.nuvamawealth.com/api-connect/login\" target=\"_blank\">here</a> &nbsp;to generate requestID&nbsp;</li>\n</ul>\n<ul>\n<li>\"D:\\nuvama python\\APIConnect-2.0.1.post1\\conf\\settings.ini\" is the settings.ini file path</li>\n</ul>\n<p>&nbsp;</p>",
                    "emtAnswer": "In order to put the end user at ease we have now provided you with code snippet of python. It's time to login and start trading with APIs.\n\nHere is the login code snippet:\n\npip install APIConnect\n\napi = APIConnect(\"apikey\",\"secret_password\",\"requestID\",True,r\"D:\\nuvama python\\APIConnect-2.0.1.post1\\conf\\settings.ini\")\n\nImportant points:\nApi key and secret password gets generated when creating an app on https://www.nuvamawealth.com/api-connect/\nPlease login here https://www.nuvamawealth.com/api-connect/login to generate requestID\n\"D:\\nuvama python\\APIConnect-2.0.1.post1\\conf\\settings.ini\" is the settings.ini file path",
                    "id": 13,
                    "question": "How to start trading journey with APIs?",
                    "questionPriority": 9,
                    "url": "/faqs/how-to-start-trading-journey-with-apis-2-13"
                },
                {
                    "answer": "<p>Please try this code only after you login</p>\n<p>&nbsp;</p>\n<p>Here is the code snippet for placing an order:</p>\n<p>&nbsp;</p>\n<p># Place trade market</p>\n<p>&nbsp;</p>\n<p>from constants.exchange import ExchangeEnum<br />from constants.order_type import OrderTypeEnum<br />from constants.product_code import ProductCodeENum<br />from constants.duration import DurationEnum<br />from constants.action import ActionEnum</p>\n<p>&nbsp;</p>\n<p>Trading_Symbol = \"UJJSMA\"</p>\n<p><br />Exchange = ExchangeEnum.NSE</p>\n<p><br />Action = ActionEnum.BUY</p>\n<p><br />Duration = DurationEnum.DAY</p>\n<p><br />Order_Type = OrderTypeEnum.MARKET</p>\n<p><br />Quantity = 1</p>\n<p><br />Streaming_Symbol = \"15228_NSE\"</p>\n<p><br />Disclosed_Quantity= \"0\"</p>\n<p><br />TriggerPrice= \"0\"</p>\n<p><br />ProductCodeENum = ProductCodeENum.CNC</p>\n<p>&nbsp;</p>\n<p>p_trd_market = api.PlaceTrade(Trading_Symbol, Exchange, Action, Duration, Order_Type, Quantity, Streaming_Symbol, Limit_Price, Disclosed_Quantity, TriggerPrice, ProductCodeENum)</p>\n<p>&nbsp;</p>\n<p>print(p_trd_market)</p>",
                    "emtAnswer": "Please try this code only after you login\n\nHere is the code snippet for placing an order:\n\n# Place trade market\n\n\nfrom constants.exchange import ExchangeEnum\nfrom constants.order_type import OrderTypeEnum\nfrom constants.product_code import ProductCodeENum\nfrom constants.duration import DurationEnum\nfrom constants.action import ActionEnum\n\nTrading_Symbol = \"UJJSMA\"\nExchange = ExchangeEnum.NSE\nAction = ActionEnum.BUY\nDuration = DurationEnum.DAY\nOrder_Type = OrderTypeEnum.MARKET\nQuantity = 1\nStreaming_Symbol = \"15228_NSE\"\nDisclosed_Quantity= \"0\"\nTriggerPrice= \"0\"\nProductCodeENum = ProductCodeENum.CNC\n\np_trd_market = api.PlaceTrade(Trading_Symbol, Exchange, Action, Duration, Order_Type, Quantity, Streaming_Symbol, Limit_Price, Disclosed_Quantity, TriggerPrice, ProductCodeENum)\n\nprint(p_trd_market)",
                    "id": 14,
                    "question": "How excited you are to put the trading APIs to use?",
                    "questionPriority": 10,
                    "url": "/faqs/how-excited-you-are-to-put-the-trading-apis-to-use-2-14"
                },
                {
                    "answer": "<p>Just use the following code to get your holdings:</p>\n<p>&nbsp;</p>\n<p>api.Holdings()</p>\n<p>&nbsp;</p>\n<p>print(\"my holdings are:\", api.Holdings())</p>",
                    "emtAnswer": "Just use the following code to get your holdings:\n\napi.Holdings()\n\nprint(\"my holdings are:\", api.Holdings())",
                    "id": 15,
                    "question": "Aren't you so excited to see your holdings after your first trade?",
                    "questionPriority": 11,
                    "url": "/faqs/arent-you-so-excited-to-see-your-holdings-after-your-first-trade-2-15"
                },
                {
                    "answer": "<p>Just put the following code to use and you will see the price feed streaming:</p>\n<p>&nbsp;</p>\n<p>&nbsp;from feed.quotes_feed import QuotesFeed</p>\n<p>&nbsp;</p>\n<p>quotes_streamer = api.initQuotesStreaming()</p>\n<p>&nbsp;</p>\n<p>def callback(resp):</p>\n<p>&nbsp;&nbsp;&nbsp; print(resp)</p>\n<p>&nbsp;</p>\n<p>quotes_streamer.subscribeQuotesFeed(symbols = [\"2885_NSE\"],&nbsp; callBack = callback)</p>",
                    "emtAnswer": "Just put the following code to use and you will see the price feed streaming:\n\nfrom feed.quotes_feed import QuotesFeed\nquotes_streamer = api.initQuotesStreaming()\n\ndef callback(resp):\n    print(resp)\n\nquotes_streamer.subscribeQuotesFeed(symbols = [\"2885_NSE\"],  callBack = callback)",
                    "id": 16,
                    "question": "Want to see the price feed for a particular stock?",
                    "questionPriority": 12,
                    "url": "/faqs/want-to-see-the-price-feed-for-a-particular-stock-2-16"
                },
                {
                    "answer": "<p>By implementing the following method, you will get to see the funds lying in your account:</p>\n<p>&nbsp;</p>\n<p>api.Limits()</p>",
                    "emtAnswer": "By implementing the following method, you will get to see the funds lying in your account:\n\napi.Limits()",
                    "id": 17,
                    "question": "Just implement the following method to know the funds lying in the account",
                    "questionPriority": 13,
                    "url": "/faqs/just-implement-the-following-method-to-know-the-funds-lying-in-the-account-2-17"
                },
                {
                    "answer": "<p>Apply the following method to see the net positions:</p>\n<p>&nbsp;</p>\n<p>api.NetPosition()</p>",
                    "emtAnswer": "Apply the following method to see the net positions:\n\napi.NetPosition()",
                    "id": 18,
                    "question": "Want to see the open positions after placing your order?",
                    "questionPriority": 14,
                    "url": "/faqs/want-to-see-the-open-positions-after-placing-your-order-2-18"
                },
                {
                    "answer": "<p>Just write the code below to see whether the market is open or close</p>\n<p>&nbsp;</p>\n<p>api.GetAMOStatus()</p>",
                    "emtAnswer": "Just write the code below to see whether the market is open or close\n\napi.GetAMOStatus()",
                    "id": 19,
                    "question": "What you should do to know the market status?",
                    "questionPriority": 15,
                    "url": "/faqs/what-you-should-do-to-know-the-market-status-2-19"
                },
                {
                    "answer": "<p>Once the session is created, it will be valid for about 12 hrs. If there is inactivity until 12 hrs, then the session gets expired.</p>",
                    "emtAnswer": "Once the session is created, it will be valid for about 12 hrs. If there is inactivity until 12 hrs, then the session gets expired.",
                    "id": 21,
                    "question": "How long the session is valid once it is created?",
                    "questionPriority": 16,
                    "url": "/faqs/how-long-the-session-is-valid-once-it-is-created-2-21"
                }
            ],
            "tabId": 2,
            "tabList": [
                {
                    "active": true,
                    "faqSection": "Client Portal",
                    "id": 2,
                    "priorityOrder": 1,
                    "showOnTradingPlatform": true,
                    "tabName": "Nuvama API connect"
                },
                {
                    "active": true,
                    "faqSection": "Client Portal",
                    "id": 3,
                    "priorityOrder": 2,
                    "showOnTradingPlatform": true,
                    "tabName": "Algo Trading"
                },
                {
                    "active": true,
                    "faqSection": "Client Portal",
                    "id": 1,
                    "priorityOrder": 3,
                    "showOnTradingPlatform": true,
                    "tabName": "How does it work?"
                },
                {
                    "active": true,
                    "faqSection": "Client Portal",
                    "id": 7,
                    "priorityOrder": 7,
                    "showOnTradingPlatform": true,
                    "tabName": "External TOTP"
                },
                {
                    "active": true,
                    "faqSection": "Client Portal",
                    "id": 8,
                    "priorityOrder": 8,
                    "showOnTradingPlatform": true,
                    "tabName": "Static IP"
                }
            ]
        },
        "vndFaq": {
            "qa": [
                {
                    "answer": "<ol>\n<li><strong>Non Interface APIs</strong><br />Manage the entire order placement and tracking experience at your end using our non-interface APIs. Access available to callbacks and end of day recon APIs as well.</li>\n<li><strong>White labelled solution</strong><br />Integrate transaction capability on your web and mobile application with trade button. Build your full-fledged investment platform using our APIs and have us deal with the operational and regulatory details.</li>\n<li><strong>Software Dev Kits (SDKs)</strong><br />SDKs are available for Android for quick integration into your mobile App. IOS &amp; Native SDKs are under development</li>\n</ol>",
                    "id": 2,
                    "question": "What are different offerings under Nuvama API connect for B2B partnerships?",
                    "questionPriority": 1,
                    "url": "/faqs/what-are-different-offerings-under-nuvama-api-connect-for-b2b-partnerships-4-2"
                }
            ],
            "tabId": 4,
            "tabList": [
                {
                    "active": true,
                    "faqSection": "Vendor Portal",
                    "id": 4,
                    "priorityOrder": 4,
                    "showOnTradingPlatform": true,
                    "tabName": "Startup & Fintech Offerings"
                }
            ]
        }
    },
    "msgID": "e34a16b8-92d0-427d-974f-7a962e7bc518",
    "srvTm": 1778232735419
}
    if (res && res.data) {
      setFaqs({
        faqId: res.data.clntFaq.qa[0].id,
        faqData: slicedData(
          res.data.clntFaq.qa,
          constants.MinFaqs,
          constants.MaxFaqs
        ),
      });
    }
  };

  const submitSignupFormRes = (res) => {
    if (res && res.data) {
      setIsServerErr({
        ...isServerErr,
        isSuccess:
          "Your request for call has been submitted. We will get back to you shortly.",
      });
      setCities(null);

      setSignupFormVal({
        nm: "",
        eml: "",
        phNo: "",
        city: "",
        state: "",
        submitedBy: "Individual",
        compName: "",
      });
    } else {
      setIsServerErr({
        ...isServerErr,
        isRejected: "Request failed, please try again after some time.",
      });
    }
  };

  const submitSignupForm = async (e) => {
    e.preventDefault();

    if (signupFormVal.submitedBy == "Individual") {
      await setSignupFormVal({ ...signupFormVal, compName: "" });
    }
    e.preventDefault();
    let Body = {
      nm: signupFormVal.nm,
      em: signupFormVal.eml,
      mob: signupFormVal.phNo,
      mod: signupFormVal.submitedBy === "Individual" ? "Client" : "Partner",
      rtg: 0,
      opt: signupFormVal.city,
      cmmt:
        signupFormVal.submitedBy === "Individual"
          ? "Client requested a callback"
          : `Partner requested a callback , company name - ${signupFormVal.compName}`,
      dev: getDevice(),
      pg: "Home page",
      url: config.url,
      ptf: "API connect",
      imgs: [],
      brw: fnBrowserDetect(),
      accode: "Guest User",
    };
    signFormSubmit(submitSignupFormRes, Body);
  };

  function onChangeSignupForm(key, value) {
    // onchange of any field remove both type of errors
    if (key === "city") {
      // separate city and state (state is blank string if not present in the value)
      const [city, state = ""] = value.split(";");
      setSignupFormVal({ ...signupFormVal, city, state });

      // if city length is greater than 2, then call the api with debounce of 300ms
      if (city.length > 2) {
        debounce(() => getCities(value), 300)();
      }
    } else {
      if (
        (key === "nm" && !alphabetExp.test(value)) ||
        (key === "phNo" && !integerExp.test(value))
      ) {
        value = signupFormVal[key];
      }

      setSignupFormVal({ ...signupFormVal, [key]: value });
    }
    setSignupErr({ ...signupErr, [key]: "" });

    return value;
  }

  function getCities(srchStr) {
    AGetCities(getCitiesRes, srchStr);
  }

  function getCitiesRes(res) {
    if (res.data && res.data.ctyLst) {
      setCities(res.data.ctyLst);
    }
  }

  function handleACBlur(value) {
    if (value.split(";").length !== 2) {
      setSignupErr({
        ...signupErr,
        city: "Please enter your city",
      });
    }
  }

  const showFaq = (id) => {
    if (faqs.faqId === id) {
      setFaqs({
        ...faqs,
        faqId: "",
      });
    } else {
      setFaqs({
        ...faqs,
        faqId: id,
      });
    }
  };

  const getResoucesRes = (res) => {
    if (res && res.data) {
      const filteredVideos = (res.data.videos || []).filter(
        (video) => video.name !== "Introducing Edelweiss API Connect"
      );
      const updatedVideos = [mp4VideoObj, ...filteredVideos];
      setResouces({
        articles: res.data.articles || [],
        videos: updatedVideos,
      });
    }
  };


  useEffect(() => {
    getFaqs(getFaqsRes);
    // getResouces(getResoucesRes);
    const body = {
      article: { pageDate: "", pageLimit: constants.Article, tag: [] },
      video: { pageDate: "", pageLimit: constants.Video, tag: [] },
    };
    getResoucesContent(getResoucesRes, body);
  }, []);

  const removeIsServerErrors = () => {
    setIsServerErr({
      isSuccess: "",
      isRejected: "",
    });
  };

  useEffect(() => {
    if (isServerErr.isSuccess !== "" || isServerErr.isRejected !== "") {
      removeServerErrors(removeIsServerErrors, constants.ErrorTimeout);
    }
  }, [isServerErr]);

  return (
    <>
      <div className="">
        <div className="homeWrap ">
          {/* banner */}
          <div className="bannerWrap ">
            <div className="container">
              <div className="bannerWrap-content">
                <div className="bannerWrap-content__wrap common-head-para">
                  <div>
                    <h1>Nuvama API Connect</h1>
                    <p>
                      <span>
                        Build, integrate and trade with our comprehensive
                      </span>
                      <span>suite of RESTful APIs and mobile SDKs</span>
                    </p>
                    <div className="bannerWrap-content__wrap_mob">
                      <p>Build, integrate and trade with our</p>
                      <p>comprehensive suite of RESTful</p>
                      <p>APIs and mobile SDKs</p>
                    </div>
                  </div>
                  {/* <div>
                    <a href="https://www.youtube.com/watch?v=CaVnFbgqSYg">
                      <div className="circle-border"></div>
                      <div>
                        <p className="">How it works?</p>
                      </div>
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          {/* take control of your trading */}
          <div className="tradingControl container">
            <div className="tradingControl-img">
              <img src={controlTrade} alt="control trading" />
            </div>
            <div className="common-head-para tradingControl-text">
              <div>
                <h2>Take Control of Your Trading</h2>
                <p>
                  Track, trade & analyze with swift execution across all major
                  exchanges in varied segments including Cash, FNO, Commodity,
                  Currency and Mutual Funds with our robust APIs
                </p>
                <div>
                  <Link to="/signup" aria-label="Sign up to get started with API connect">Get started with API connect</Link>
                </div>
              </div>
            </div>
          </div>
          {/* get free access  */}
          <GetAccess
            title={GetAccecssTitle.HOME_TITLE}
            GetAccessData={GetAccessHome}
          />
          {/* trade in a language of your choice */}
          <div className="tradeLang container  ">
            <div className="display-flex-center">
              <div>
                <p className="smallText greyText">
                  Trade in a language of your choice
                </p>
                <ul className="display-flex">
                  <li>
                    <a
                      href={urlConfig.python_language}
                      target="_blank"
                      aria-label="Python (opens in new tab)"
                      rel="noopener noreferrer"
                    >
                    <img className="python" src={python} alt="Python"/>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Java (opens in new tab)"
                      href={urlConfig.java_language}
                    >
                      <img className="java" src={java} alt="Java"></img>  
                    </a>
                  </li>

                  <li>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Node Js (opens in new tab)"
                      href={urlConfig.node_language}
                    >
                      <img className="node" src={node} alt="Node.js"></img>  
                    </a>
                  </li>
                  {/* <li>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={urlConfig.c_language}
                    >
                      C#
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>

          {/* startup and fintech offerings */}
          <div className="learnTrade container ">
            <div className="learnTrade-img_mob">
              <img src={learnTrade} alt="learn trading" />
            </div>
            <div>
              <OfferSection Offers={Offers} title={OfferTitle.HOME_TITLE} />

              <div>
                <Link className="text_btn anchor_tag" to="/signup">Request For Access</Link>
              </div>
            </div>
            <div>
              <div className="learnTrade-img_destop">
                <img src={learnTrade} alt="" aria-hidden="true" />
              </div>
            </div>
          </div>

          {/* learn about trading with algos */}
          <div className="tradingAlgos">
            <div className="container">
              {resouces &&
                resouces.videos &&
                resouces.videos.map((video) => {
                  return video.ishighlighted === true ? (
                    <VideoBanner key={video.resourceId} video={video} />
                  ) : null;
                })}

              <div>
                <div className="custom-row articleVideoWrap articalVedio_row">
                  <div className="grid_item_1 ">
                    <div className="article">
                      <div>
                        <h3>Articles</h3>
                      </div>
                      <div className="article_section_wrap">
                        {resouces &&
                          resouces.articles &&
                          resouces.articles.map((article) => {
                            return (
                              <Article
                                key={article.resourceId}
                                article={article}
                              />
                            );
                          })}
                      </div>
                      <div>
                          <Link className="text_btn anchor_tag" to="/articles">View All Articles</Link>
                      </div>
                    </div>
                  </div>
                  <div className="grid_item_2">
                    <div className="article videos">
                      <div>
                        <h3>Videos</h3>
                      </div>
                      <div className="article_section_wrap">
                        <div className="videoWraps">
                          {resouces &&
                            resouces.videos &&
                            resouces.videos.map((video) => {
                              return video.ishighlighted !== true ? (
                                <Video key={video.resourceId} video={video} />
                              ) : null;
                            })}
                        </div>
                      </div>
                      <div>
                          <Link className="text_btn anchor_tag" to="/videos">View All Videos</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* faqs */}
          <div className="faqsWrap">
            <div className="faqs container">
              <h2 className="common-subHead">Frequently Asked Questions</h2>
              <div class="panel-group" id="accordion">
                {faqs.faqData !== ""
                  ? faqs.faqData.map((faq) => {
                      const isExpanded = faqs.faqId === faq.id;
                      const headingId = `faq-heading-${faq.id}`;
                      const panelId = `faq-panel-${faq.id}`;

                      return (
                        <div
                          key={faq.id}
                          className="panel panel-default"
                          onClick={() => showFaq(faq.id)}
                        >
                          <div
                            className="panel-heading"
                            id={headingId}
                          >
                            <div className="panel-title">
                              <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    showFaq(faq.id);
                                  }}
                                aria-expanded={isExpanded}
                                aria-controls={panelId}
                                className="pointer"
                                style={{
                                  background: "none",
                                  border: "none",
                                  width: "100%",
                                  textAlign: "left",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  padding: 0,
                                }}
                              >
                                {isExpanded ? (
                                  <i className="edel-icon-minus" aria-hidden="true" />
                                ) : (
                                  <i className="edel-icon-plus" aria-hidden="true" />
                                )}
                                <span className="faq-question-text">{faq.question}</span>
                              </button>
                            </div>
                          </div>
                          <div
                            id={panelId}
                            role="region"
                            aria-labelledby={headingId}
                            className="panel-collapse collapse"
                            hidden={!isExpanded}
                            aria-hidden={!isExpanded}
                          >
                            <div className="panel-body">
                              <p
                                dangerouslySetInnerHTML={{ __html: faq.answer }}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
              <div className="showAllLink text_btn">
                <Link to="/support" aria-label="Show all FAQs">Show all</Link>
              </div>
            </div>
          </div>
          {/* have more question for us? - form */}
          <div className="askQuesForm">
            <div className="container">
              {/* <div className="custom-row"> */}
              <div className="custom-grid">
                {/* <div className="custom-col info-col"> */}
                <div className=" info-col">
                  <div className="info-col-wrap">
                    <div className="form-heading">
                      <h2>Have more <br/> questions for us?</h2>
                    </div>
                    <p>Lets us give you a call</p>
                  </div>
                </div>
                {/* <div className="custom-col form--col"> */}
                <div className=" form--col">
                  <form>
                    <p className="input-label">All fields are mandatory.</p>
                    <div class="form-group">
                      <label htmlFor="name" className="input-label">
                        Name
                      </label>
                      <InputField
                        id="name"
                        required
                        pattern={betweenNChars(3)}
                        onChange={(value) => onChangeSignupForm("nm", value)}
                        onBlur={(error) =>
                          setSignupErr({
                            ...signupErr,
                            nm: error.pattern
                              ? ""
                              : "Please enter at least 3 character",
                          })
                        }
                        defaultValue={signupFormVal.nm}
                        className="login_inp mg-b40"
                        placeholder="Eg: Name Surname"
                        errorText={signupErr.nm}
                      />
                    </div>
                    <div class="form-group">
                      <label htmlFor="email" className="input-label">
                        Email id
                      </label>
                      <InputField
                        id="email"
                        required
                        placeholder="Eg: example@email.com"
                        pattern={emailRegex}
                        onChange={(value) => onChangeSignupForm("eml", value)}
                        onBlur={(error) =>
                          setSignupErr({
                            ...signupErr,
                            eml: error.pattern
                              ? ""
                              : "Please enter a valid email id",
                          })
                        }
                        defaultValue={signupFormVal.eml}
                        className="login_inp mg-b40"
                        errorText={signupErr.eml}
                      />
                    </div>
                    <div class="form-group">
                      <label htmlFor="phone" className="input-label">
                        Mobile Number
                      </label>
                      <InputField
                        id="phone"
                        required
                        type="tel"
                        pattern={phoneNo}
                        onChange={(value) => onChangeSignupForm("phNo", value)}
                        onBlur={(error) =>
                          setSignupErr({
                            ...signupErr,
                            phNo: error.pattern
                              ? ""
                              : "Please enter a valid 10 digit mobile number",
                          })
                        }
                        defaultValue={signupFormVal.phNo}
                        className="login_inp mg-b30"
                        placeholder="Eg: 980908XXXX"
                        errorText={signupErr.phNo}
                      />
                    </div>
                    <div class="form-group">
                      <label htmlFor="city" className="input-label">
                        City
                      </label>
                      <Autocomplete
                        id="city"
                        required
                        data={
                          cities
                            ? cities.map((city) => ({
                                value: city.city + ";" + city.state,
                                display: city.city,
                              }))
                            : null
                        }
                        onOptionSelect={(value) =>
                          onChangeSignupForm("city", value.value)
                        }
                        noDataMsg="City with similar name not found"
                        onChange={(value) => onChangeSignupForm("city", value)}
                        inputClassName="login_inp mg-b40"
                        placeholder="Eg: Mumbai"
                        onBlur={handleACBlur}
                        name="city"
                        defaultValue={signupFormVal.city}
                        className="city"
                      />
                    </div>
                    {signupFormVal.submitedBy === "Partner" && (
                      <div class="form-group">
                        <label htmlFor="company-name" className="input-label">
                          Company Name
                        </label>
                        <InputField
                          id="company-name"
                          pattern={betweenNChars(3)}
                          onChange={(value) =>
                            onChangeSignupForm("compName", value)
                          }
                          onBlur={(error) =>
                            setSignupErr({
                              ...signupErr,
                              compName: error.pattern
                                ? ""
                                : "Please enter at least 3   character",
                            })
                          }
                          defaultValue={signupFormVal.compName}
                          className="login_inp mg-b40"
                          placeholder="Eg: Example Pvt. Ltd."
                          errorText={signupErr.compName}
                        />
                      </div>
                    )}
                    <div>
                      <fieldset
                        className="custom_radio"
                        style={{ border: "none", padding: 0, margin: 0 }}
                      >
                        <legend className="sr-only">Submitted by</legend>

                        <div className="radioBtn">
                          <input
                            type="radio"
                            id="radio-individual"
                            name="radio-group"
                            value="Individual"
                            checked={signupFormVal.submitedBy === "Individual"}
                            onChange={() =>
                              setSignupFormVal({
                                ...signupFormVal,
                                submitedBy: "Individual",
                              })
                            }
                          />
                          <label htmlFor="radio-individual">Individual</label>
                        </div>

                        <div className="radioBtn">
                          <input
                            type="radio"
                            id="radio-partner"
                            name="radio-group"
                            value="Partner"
                            checked={signupFormVal.submitedBy === "Partner"}
                            onChange={() =>
                              setSignupFormVal({
                                ...signupFormVal,
                                submitedBy: "Partner",
                              })
                            }
                          />
                          <label htmlFor="radio-partner">Partner</label>
                        </div>

                      </fieldset>
                    </div>
                    {isServerErr.isSuccess !== "" && (
                      <div className="server_responce">
                        <span className=" green">{isServerErr.isSuccess} </span>
                      </div>
                    )}
                    {isServerErr.isRejected !== "" && (
                      <div className="server_responce">
                        <span className=" red">{isServerErr.isRejected} </span>
                      </div>
                    )}
                    <div>
                      <button
                        onClick={submitSignupForm}
                        className="btn white-btn"
                        disabled={
                          Object.values(signupErr).every((error) => error) ||
                          Object.values(signupFormVal).some((value) => !value)
                          // props.disableForm
                        }
                      >
                        Request A Call
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* footer */}
          <Footer />
          {!authContext.isAuth ? (
            <div className="mob_footer">
              <div className="home_footer">
                <Link to="/signup" className="btn">
                  Sign-up
                </Link>
                <Link to="/login" className="border-btn">
                  Login
                </Link>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};
export default Home;
